import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function Faq() {
  const { t, lang } = useLang();
  const [faqs, setFaqs] = useState([]);
  const suffix = lang === "hi" ? "Hi" : lang === "ta" ? "Ta" : "";
  const pick = (obj, base) => obj[base + suffix] || obj[base];

  useEffect(() => {
    api.get("/api/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-3xl px-4 py-14" data-testid="faq-page">
      <h1 className="font-display text-4xl font-semibold sm:text-5xl" data-testid="faq-page-title">{t("faq.title")}</h1>
      <p className="mt-3 text-base text-muted-foreground md:text-lg">{t("faq.sub")}</p>
      <Accordion type="single" collapsible className="mt-8" data-testid="faq-list">
        {faqs.map((f) => (
          <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`}>
            <AccordionTrigger className="text-left text-sm font-semibold">{pick(f, "q")}</AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{pick(f, "a")}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
